import { LayaGL } from "../layagl/LayaGL";
import { PAL } from "../platform/PlatformAdapters";
import { Browser } from "../utils/Browser";
import { Config } from "./../../Config";
import { ILaya } from "./../../ILaya";
export class Render {
    static __init__() {
        Render.frameInterval = 1000 / Config.FPS;
        let timeId = 0;
        PAL.browser.on("visibilitychange", (visible) => {
            if (!visible)
                timeId = window.setInterval(Render.loop, 1000);
            else if (timeId != 0)
                window.clearInterval(timeId);
        });
        Render.startLoop();
    }
    static startLoop() {
        let lastFrmTm = performance.now();
        let first = true;
        let startTm = 0;
        let requestFrame = PAL.browser.requestFrame;
        function loop(stamp) {
            let sttm = performance.now();
            lastFrmTm = sttm;
            if (first) {
                startTm = Math.floor(stamp / Render.frameInterval) * Render.frameInterval;
                first = false;
            }
            stamp -= startTm;
            let frm = Math.floor(stamp / Render.frameInterval);
            let dfrm = frm - Render.lastFrame;
            if (dfrm > 0 || !Config.fixedFrames) {
                Render.lastFrame = frm;
                Render.loop();
            }
            requestFrame(loop);
        }
        requestFrame(loop);
    }
    static loop() {
        LayaGL.statAgent.startFrameLogic();
        this._globalRepaintGet = this._globalRepaintSet;
        this._globalRepaintSet = false;
        ILaya.stage.render();
        LayaGL.statAgent.endFrameLogic();
    }
    static vsyncTime() {
        return Render.lastFrame * Render.frameInterval;
    }
    static isGlobalRepaint() {
        return Render._globalRepaintGet;
    }
    static setGlobalRepaint() {
        Render._globalRepaintSet = true;
    }
    static get canvas() {
        return Browser.mainCanvas.source;
    }
}
Render.frameInterval = 1000 / 60;
Render.lastFrame = 0;
Render._globalRepaintSet = false;
Render._globalRepaintGet = false;
